import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import "./flash-news-modal.scss";

interface FlashNewsProps {
  visible: boolean;
  onHide: () => void;
  data?: {
    title: string;
    subtitle: string;
    image: string;
    features?: string[];
    cta?: {
      label: string;
      description: string;
    };
  };
}

const FlashNewsModal: React.FC<FlashNewsProps> = ({
  visible,
  onHide,
  data = {
    title: "Sanjeevini",
    subtitle: "Kashaya powder",
    image: "https://farm2me.azurewebsites.net/images/farm2me/Banner.jpg",
    features: [
      "Supports Diabetic Health",
      "Balances BP & Heart Health",
      "Improves Digestion & Gut Strength",
      "Boosts Immunity Naturally",
      "Anti-Inflammatory & Detoxifying",
    ],
    cta: {
      label: "Shop Now",
      description: "Begin each day with the designated millet pack on an empty stomach >",
    },
  },
}) => {
  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      modal
      className="flash-news-dialog"
      header="Flash News"
      headerClassName="flash-news-header"
      contentClassName="flash-news-content"
      style={{ maxWidth: "800px", width: "90vw" }}
      breakpoints={{ "960px": "92vw", "641px": "95vw" }}
    >
      <div className="flash-news-container">
        {/* Full Width Image with Scrollable Overflow */}
        <div className="flash-news-image-wrapper">
          <img src={data.image} alt={data.title} className="flash-news-image" />
        </div>
      </div>
    </Dialog>
  );
};

export default FlashNewsModal;
